import styled from 'styled-components';

export const CellContent = styled.div`
  margin: 0;
  padding: 15px 0;

  a {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;
